import { render, staticRenderFns } from "./PrizeItem.vue?vue&type=template&id=ae0872f8&scoped=true"
import script from "./PrizeItem.vue?vue&type=script&lang=js"
export * from "./PrizeItem.vue?vue&type=script&lang=js"
import style0 from "./PrizeItem.vue?vue&type=style&index=0&id=ae0872f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0872f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae0872f8')) {
      api.createRecord('ae0872f8', component.options)
    } else {
      api.reload('ae0872f8', component.options)
    }
    module.hot.accept("./PrizeItem.vue?vue&type=template&id=ae0872f8&scoped=true", function () {
      api.rerender('ae0872f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/draw/activity/components/PrizeItem.vue"
export default component.exports